<template>
  <a-spin :spinning="confirmLoading">
    <a-form-model :model="model" :rules="validatorRules" ref="form">
      <fieldset>
        <legend>&nbsp;缺陷信息&nbsp;</legend>
        <div class="text item">
          <a-form layout="inline">
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="设备名称:" style="margin-bottom: 5px">
                  <span>{{ defHandle.devName }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="设备类型:" style="margin-bottom: 5px">
                  <span>{{ defHandle.devClassId_dictText }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="缺陷部位类别:" style="margin-bottom: 5px">
                  <span>{{ defHandle.defStandardName }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="缺陷等级:" style="margin-bottom: 5px">
                  <span>{{ defHandle.defLevel_dictText }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item label="缺陷内容:" style="margin-bottom: 5px">
                  <span>{{ defHandle.defContent }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="缺陷发现时间:" style="margin-bottom: 5px">
                  <span>{{ defHandle.defFindTime }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="联系电话:" style="margin-bottom: 5px">
                  <span>{{ defHandle.defTelephone }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="12">
                <a-form-model-item label="缺陷发现人:" style="margin-bottom: 5px">
                  <span>{{ defHandle.defInventor_dictText }}</span>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item label="缺陷处理人:" style="margin-bottom: 5px">
                  <span>{{ defHandle.defHandle_dictText }}</span>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item label="缺陷图片:" style="margin-bottom: 5px">
                  <j-image-upload :file-list="defHandle.defPicture" bizPath="scott/pic" class="pt-20px" disabled></j-image-upload>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-model-item label="缺陷视频:" style="margin-bottom: 5px">
                  <a-upload
                    :file-list="defHandle.defVideo"
                    @change="handleChange1"
                    @preview="videoPreview"
                    disabled
                    listType="picture-card"
                  ></a-upload>
                  <!-- <a-modal :footer="null" :visible="videoPreviewVisible" @cancel="handleCancel1">
                                            <video width="100%" height="100%" controls="controls" id="video">
                                                您的浏览器不支持播放该视频！
                                            </video>
                  </a-modal>-->
                  <j-modal
                    :footer="null"
                    :okButtonProps="{ class:{'jee-hidden': true} }"
                    :visible="videoPreviewVisible"
                    :width="600"
                    @cancel="handleCancel1"
                    cancelText="关闭"
                    switchFullscreen
                    title="缺陷视频"
                  >
                    <video autoplay controls="controls" id="video" width="100%">您的浏览器不支持播放该视频！</video>
                  </j-modal>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form>
        </div>
      </fieldset>
      <fieldset>
        <legend>&nbsp;缺陷处理&nbsp;</legend>
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="处理时间" prop="handleTime">
              <j-date
                :showTime="true"
                dateFormat="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择处理时间"
                v-model="model.handleTime"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="处理人" prop="defHandle">
              <j-dict-select-tag
                :dictCode="`sys_user,realname,id,del_flag='0' and executor_maintain = 1 and rel_tenant_ids='${this.$ls.get('TENANT_ID')}' order by realname`"
                pageSize="100"
                placeholder="请选择缺陷处理人"
                type="list"
                v-model="model.defHandle"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </fieldset>
      <fieldset>
        <legend>&nbsp;备件消耗&nbsp;</legend>
        <a-row>
          <a-col :span="24">
            <!-- 消耗得备品备件列表 -->
            <DevBpbjLeadoutRecordList :canEdit="true" :showTitle="false" @addBj="addBj" ref="devBpbjLeadoutRecordList"></DevBpbjLeadoutRecordList>
          </a-col>
        </a-row>
      </fieldset>
      <fieldset>
        <legend>&nbsp;现场情况&nbsp;</legend>
        <a-row>
          <a-col :span="24">
            <a-form-model-item
              :labelCol="{xs: { span: 24 },sm: { span: 3 }}"
              :wrapperCol="{xs: { span: 24 },sm: { span: 20 }}"
              label="关联图片"
              prop="formData.picture"
            >
              <a-upload
                :action="minioUploadAction"
                :before-upload="beforeUpload"
                :file-list="model.formData.picture"
                :headers="tokenHeader"
                @change="handleChange"
                @preview="handlePreview"
                accept="image/*"
                listType="picture-card"
              >
                <div v-if="model.formData.picture.length < 4">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">上传关联图片</div>
                </div>
              </a-upload>
              <a-modal :footer="null" :visible="previewVisible" @cancel="handleCancel">
                <img :src="previewImage" alt="example" style="width: 100%" />
              </a-modal>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item
              :labelCol="{xs: { span: 24 },sm: { span: 3 }}"
              :wrapperCol="{xs: { span: 24 },sm: { span: 20 }}"
              label="缺陷视频"
              prop="formData.video"
            >
              <a-upload
                :action="minioUploadAction"
                :before-upload="beforeUpload1"
                :file-list="model.formData.video"
                :headers="tokenHeader"
                @change="handleChange1"
                @preview="videoPreview"
                accept="video/*"
                listType="picture-card"
              >
                <div v-if="model.formData.video.length < 4">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">上传缺陷视频</div>
                </div>
              </a-upload>
              <a-modal :footer="null" :visible="videoPreviewVisible" @cancel="handleCancel1">
                <video controls="controls" height="600px;" id="video" width="100%">您的浏览器不支持播放该视频！</video>
              </a-modal>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item
              :labelCol="{xs: { span: 24 },sm: { span: 3 }}"
              :wrapperCol="{xs: { span: 24 },sm: { span: 20 }}"
              label="消缺过程描述"
              prop="formData.description"
            >
              <a-textarea allow-clear placeholder="请输入消缺过程描述" v-model="model.formData.description"></a-textarea>
            </a-form-model-item>
          </a-col>
        </a-row>
      </fieldset>
      <fieldset>
        <legend>&nbsp;任务状态&nbsp;</legend>
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="消缺状态" prop="status">
              <a-radio-group button-style="solid" v-model:value="model.status">
                <a-radio-button value="2">继续处理</a-radio-button>
                <a-radio-button value="3">完结</a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
        </a-row>
      </fieldset>
    </a-form-model>
    <!-- 备品备弹窗件列表 -->
    <DevBpbjInfoList
      :repairPlanId="planId"
      :taskTable="taskTable"
      :title="deviceName"
      @refresList="refresList"
      ref="DevBpbjInfoList"
    ></DevBpbjInfoList>
  </a-spin>
</template>

<script>
  import moment from 'moment'
  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import { validatenull, validatenotnull } from '@/utils/validate'
  import { getUserList } from '@/api/api'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EditableCell from '@/views/eMaintenance/modules/EditCell.vue'
  import DevBpbjInfoList from '@/views/eMaintenance/modules/DevBpbjInfoList'
  import DevBpbjLeadoutRecordList from '@/views/eMaintenance/modules/DevBpbjLeadoutRecordList'
  import { omit } from 'lodash'

  export default {
    name: 'EvntProcessInfoForm',
    mixins: [JeecgListMixin],
    components: {
      EditableCell,
      DevBpbjInfoList,
      DevBpbjLeadoutRecordList,
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
    },
    data () {
      return {
        disableMixinCreated: true,
        model: {
          handleTime: moment(new Date(), 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'), //默认值
          processorId: '',
          status: undefined,
          defHandle: '',
          formData: {
            picture: [],
            video: [],
            description: '',
          }
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          handleTime: [
            { required: true, message: '请选择处理时间!' },
          ],
          defHandle: [
            { required: true, message: '请选择处理人!' },
          ],
          status: [
            { required: true, message: '请选择消缺状态!' },
          ],
        },
        url: {
          handle: "/device/defRegister/handle",
          minioUpload: "/sys/upload/uploadMinio",

        },
        UserOptions1: [],
        UserOptions2: [],
        previewVisible: false,
        previewImage: '',
        defHandle: {},
        deviceName: '',
        taskTable: 'defect',
        videoPreviewVisible: false,
        previewVideo: '',
      }
    },
    watch: {
      //预览并播放视频时,如果关闭了弹框,电脑还有视频的声音,监听视频预览的弹框的打开/关闭,如果关闭了弹框就让video不要播放了
      videoPreviewVisible: function (val) {
        if (val === false) {
          const video = document.getElementById('video')
          video.pause()
        }
      },
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
      minioUploadAction () {
        return window._CONFIG['domianURL'] + this.url.minioUpload;
      },
      userInfo () {
        return this.$store.getters.userInfo
      },
      planId () {
        return this.defHandle.id
      }
    },
    created () {
      this.remoteUserList1()
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {

        if (validatenull(record.id)) {
          this.$message.error('来源id不允许为空,请检查.')
          return
        }

        this.defHandle = record
        this.model.id = record.id;
        this.model.defHandle = this.userInfo.id
        if (validatenull(this.model.formData.picture)) {
          this.model.formData.picture = []
        }
        if (validatenull(this.model.formData.video)) {
          this.model.formData.video = []
        }
        this.model.processorId = this.userInfo.id
        this.visible = true;
        // 调用 消耗备品备件列表数据
        if (record && record.id) {
          this.$refs.devBpbjLeadoutRecordList.getData(record.id)
        }

      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            this.model.bpbjLeadoutList = this.$refs.devBpbjLeadoutRecordList.dataSource.map(map => {
              map.bjModelId = map.id;
              omit(map, ['id']);
              return map;
            });
            httpAction(this.url.handle, this.model, 'post').then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      remoteUserList1 (query) {
        let params = {
          username: query,
          // realname: query,
          // phone: query,
          // workNo: query
        }
        let sqp = {}
        // sqp['superQueryParams'] = encodeURI(params)
        // sqp['superQueryMatchType'] = 'or'
        getUserList(Object.assign(sqp, { pageSize: 999999 })).then(res => {
          this.UserOptions1 = res.result.records;
        })
      },
      remoteUserList2 (query) {
        let params = {
          username: query,
          // realname: query,
          // phone: query,
          // workNo: query
        }
        let sqp = {}
        // sqp['superQueryParams'] = encodeURI(params)
        // sqp['superQueryMatchType'] = 'or'
        getUserList(Object.assign(sqp, { pageSize: 999999 })).then(res => {
          this.UserOptions2 = res.result.records;
        })
      },
      filterOption (input, option) {
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
      handleCancel () {
        this.previewVisible = false
      },
      handlePreview (file) {
        this.previewImage = file.url || file.thumbUrl
        this.previewVisible = true
      },
      handleChange (info) {
        if (info.file.status === 'done') {
          if (info.file.response.success) {
            this.$message.success(`${info.file.name} 上传成功!`);
          } else {
            this.$message.error(`${info.file.response.message}`);
          }
        } else if (info.file.status === 'error') {
          this.$message.error(`${info.file.response.message}`);
        }
        if (validatenotnull(info.fileList)) {
          this.model.formData.picture = info.fileList.map(item => {
            let url = (validatenotnull(item.url)) ? item.url : ((validatenotnull(item.response) && validatenotnull(item.response.message)) ? item.response.message : '')
            return {
              uid: item.uid,
              name: item.name,
              status: item.status,
              url: url
            }
          })
          // console.error(this.model.formData.picture)
          // console.error(info.fileList)
        }
      },
      beforeUpload (file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
          this.$message.error('You can only upload JPG/PNG file!');
        }
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
          this.$message.error('Image must smaller than 10MB!');
        }
        return isJpgOrPng && isLt10M;
      },
      addBj () {
        if (!this.planId) {
          this.$message.error('缺陷id不允许为空,请检查.')
          return
        }
        this.deviceName = `${this.defHandle?.devName}：消耗备件`
        this.$refs.DevBpbjInfoList.open(this.defHandle)
      },
      // 消耗备品备件列表
      refresList (list) {
        const recordList = this.$refs.devBpbjLeadoutRecordList.dataSource
        this.$refs.devBpbjLeadoutRecordList.dataSource = recordList.concat(list)
      },
      handleCancel1 () {
        this.videoPreviewVisible = false
      },
      handleChange1 (info) {
        if (info.file.status === 'done') {
          if (info.file.response.success) {
            this.$message.success(`${info.file.name} 上传成功!`);
          } else {
            this.$message.error(`${info.file.response.message}`);
          }
        } else if (info.file.status === 'error') {
          this.$message.error(`${info.file.response.message}`);
        }
        if (validatenotnull(info.fileList)) {
          this.model.formData.video = info.fileList.map(item => {
            let url = (validatenotnull(item.url)) ? item.url : ((validatenotnull(item.response) && validatenotnull(item.response.message)) ? item.response.message : '')
            return {
              uid: item.uid,
              name: item.name,
              status: item.status,
              url: url
            }
          })
          // console.error(this.model.formData.video)
          // console.error(info.fileList)
        }
      },
      beforeUpload1 (file) {
        const isVideo = file.type === 'video/mp4' || file.type === 'video/ogg' || file.type === 'video/webm';
        if (!isVideo) {
          this.$message.error('You can only upload video file!');
        }
        const isLt50M = file.size / 1024 / 1024 < 50;
        if (!isLt50M) {
          this.$message.error('Image must smaller than 50MB!');
        }
        return isVideo && isLt50M;
      },
      videoPreview (file) {
        //预览视频的方法
        this.videoPreviewVisible = true;
        this.$nextTick(() => { //这里一定要使用nextTick,否则document将找不到id为video的节点,因为modal框初始为隐藏状态,<video id='video'>标签初始在dom树中并不存在
          const video = document.getElementById('video')
          video.src = file.url
        })
      },
    }
  }
</script>